/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import router from '../router'
import pinia from '../store'
import vuetify from './vuetify'
import toast from './toast'  // Importa o plugin de toast


export function registerPlugins (app) {
  app
  .use(pinia)  // Registra o Pinia
  .use(router)
  .use(vuetify)
  .use(toast)  // Registra o plugin de toast
}
